<template>
    <div>
        <div class="content-box">
            <div class="row element-wrapper">
                <div class="col-sm-4" style="width: 310px;">
                    <div class="element-box mb-0">
                        <h5 class="form-header">Preciadores Miniso</h5>
                        <span style="font-size: 15px;">Añadir Productos Manualmente</span>
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label v-bind:class="{
                                        'text-danger': current.errors & current.errors.tienda,
                                    }"></label>
                                    <TiendaSelectComponent :current="current" :disabled="precios_imprimir.length > 0" />
                                    <br />
                                    <ProductoSelectComponentV2 :current="current" @onChangeProducto="seleccionProducto">
                                    </ProductoSelectComponentV2>
                                    <small v-if="current.errors && current.errors.proveedor"
                                        class="form-text text-danger">{{
                                            current.errors.proveedor }}</small>
                                    <div>
                                        <button @click="agregarProducto()" class="btn btn-success btn-md"
                                            :disabled="!validacion">
                                            <span>Agregar&nbsp; <i class="fas fa-plus"></i></span>
                                        </button>
                                        <button class="btn btn-md btn-danger" @click="refreshDataDefault">
                                            Limpiar Todo&nbsp; <i class="fas fa-sync"></i>
                                        </button>
                                        <hr>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br>
                        <form @submit.prevent="agregarProductoConBarra">
                            <span style="font-size: 15px;">Añadir Productos por Barra</span>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label></label>
                                        <br />
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <label
                                                    v-bind:class="{ 'text-danger': buscar_por_barra.errors.barra && buscar_por_barra.errors.barra.length > 0 }">Barra</label>
                                                <input v-model="buscar_por_barra.barra" autofocus="autofocus"
                                                    class="form-control" placeholder="Barra" type="text"
                                                    v-bind:class="{ 'is-invalid': buscar_por_barra.errors.barra && buscar_por_barra.errors.barra.length > 0 }">
                                                <small v-if="current.errors && buscar_por_barra.errors.barra"
                                                    class="form-text text-danger">{{ buscar_por_barra.errors.barra
                                                    }}</small>
                                            </div>
                                            <button class="btn btn-success btn-md" type="submit">
                                                <span>Agregar &nbsp; <i class="fas fa-plus"></i></span>
                                            </button>
                                            <button class="btn btn-md btn-danger" @click="refreshDataDefault">
                                                <span>Limpiar</span> &nbsp;<i class="fas fa-sync"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="col-sm-8">
                    <div class="element-box">
                        <h4>Listado de Productos a Imprimir</h4>
                        <br><br>
                        <div class="row">
                            <div class="col-4" v-for="(current_preview, index) in precios_imprimir"
                                style="height: 145px; border:solid 1px #ccc;">
                                <button class="btn btn btn-outline-danger" @click="quitarItem(current_preview)">
                                    <span class="short-text">
                                        <i class="fas fa-times"></i>
                                    </span>
                                </button>
                                <br>
                                <table>
                                    <tr>
                                        <td style="background-color: #FFFFFF;">
                                            <br>
                                            <span
                                                style="font-size: 30px; font-weight: bold;  color: red; text-align: center;">
                                                Q {{ convertToInt(current_preview.precio_1.precio) }}
                                            </span>
                                        </td>
                                        <td style="padding: 0px;">
                                            <table>
                                                <tr>
                                                    <td
                                                        style="font-size: 12px; font-weight: bold; max-height: 5px; padding: 0px;">
                                                        <div
                                                            style="width: 100% !important; height: 60px;  overflow: hidden; text-overflow: ellipsis; text-align: center; vertical-align: middle;">
                                                            {{ current_preview.producto.nombre }}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="padding: 0px; text-align: center;">
                                                        <span style="font-size: 14px; font-weight: bold;">
                                                            {{ current_preview.barra }}</span>

                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="form-buttons-w">
                            <div class="btn-group dropright glow-on-hover">
                                <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-print"></i> &nbsp; Imprimir
                                </button>
                                <div class="dropdown-menu">
                                    <button class="dropdown-item" @click="Imprimir()"
                                        :disabled="precios_imprimir.length == 0">Habladores Pequeños &nbsp; <i
                                            class="os-icon os-icon-grid-squares"></i></button>
                                    <button class="dropdown-item" @click="ImprimirMedianos()"
                                        :disabled="precios_imprimir.length == 0">Habladores Medianos &nbsp; <i
                                            class="os-icon os-icon-grid-squares-2"></i></button>
                                    <button class="dropdown-item" :disabled=true>Habladores
                                        Grandes
                                        &nbsp;&nbsp;&nbsp;&nbsp; <i class="os-icon os-icon-square"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import DynamicService from "../../../services/commons/DynamicService";

export default {
    components: {
        ProductoSelectComponentV2,
        TiendaSelectComponent,
    },
    data() {
        return {
            tienda_id: null,
            precio_1: '',
            current: {
                tienda: '01',
                producto: {
                    sku: null
                },
                errors: {
                },
                precios_lista: [],
                precio_1: null,
                precio_2: null,
                texto: null,
                barra: ''
            },
            buscar_por_barra: {
                barra: '',
                errors: {

                }
            },
            precios_imprimir: [],
            datos: [],
            datos_: [],
        };
    },
    computed: {
        validacion: function () {
            let self = this;
            if (self.current.tienda == null) {
                return false;
            }
            if (self.current.producto.sku == null) {
                return false;
            }
            return true;
        }
    },
    methods: {
        refreshDatos(producto) {
            let self = this;
            DynamicService.getActionList("cat", "productos", "obtener_precio_por_tienda", {
                producto: producto,
            }).then((response) => {
                console.log(response.data, "xxx")
                self.datos_.push(response.data);
            });
        },
        obtenerBarraProducto(producto) {
            let _barra = '';

            DynamicService.fetch("cat", "producto-barra", {
                producto: producto.sku,
            }).then((response) => {
                _barra = response.data.results[0].barra;
            });

            if (_barra == '') {
                return producto.sku;
            }
            return _barra;
        },
        agregarProductoConBarra() {
            let self = this;

            DynamicService.getByIdParams("cat", "productos", self.buscar_por_barra.barra, {
                tienda: self.current.tienda,
                sku: self.buscar_por_barra.barra,
            }).then((response) => {
                self.current.producto = response.data;
                self.current.precios_lista = response.data.lista_precios;

                self.current.precio_1 = self.current.precios_lista[self.current.precios_lista.length - 1];
                self.agregarProducto();

                self.buscar_por_barra = {
                    barra: '',
                    errors: {

                    }
                };
            });

        },
        agregarProducto() {
            let self = this;
            if (!self.current.tienda) {
                Notifications.alert.error(
                    "Agregar producto",
                    "El campo de tienda es obligatorio"
                );
                return;
            }
            if (self.current.precio_1 == null) {
                return;
            }
            if (self.precios_imprimir.length > 32) {
                // El array tiene más de 5 objetos, realizar una acción en consecuencia
                Notifications.alert.error(
                    "Agregar producto",
                    "solo se pueden agregar un maximo de 32 productos"
                );
                return;
            }
            if (self.tienda_id == null) {
                self.tienda_id = self.current.tienda;
            }

            if (self.tienda_id != self.current.tienda) {
                Notifications.alert.error(
                    "Agregar producto",
                    "Debe seleccionar la misma tienda"
                );
                return;
            }
            self.current.barra = self.obtenerBarraProducto(self.current.producto);
            self.precios_imprimir.push(Object.assign({}, self.current))
            self.current = Object.assign(self.current, {
                producto: {
                    sku: null
                },
                errors: {
                },
                precios_lista: [],
                precio_1: null,
                precio_2: null,
                texto: null
            });
            // self.functionAgregar();
        },
        functionAgregar() {
            let self = this;
            let nextIndex = self.datos.length + 1;
            let producto = {};
            producto[`p${nextIndex}`] = self.current.producto.sku;
            self.datos.push(producto);
            self.refreshDatos(self.current.producto.sku);
        },
        Imprimir() {
            let self = this;
            const baseApiUrl = process.env.VUE_APP_ROOT_API;
            var reportName = "catalogos/HabladoresCant4x10.jrxml&";


            let paramsObject = {
                tienda: self.tienda_id,
                p1: '',
                p2: '',
                p3: '',
                p4: '',
                p5: '',
                p6: '',
                p7: '',
                p8: '',
                p9: '',
                p10: '',
                p11: '',
                p12: '',
                p13: '',
                p14: '',
                p15: '',
                p16: '',
                p17: '',
                p18: '',
                p19: '',
                p20: '',
                p21: '',
                p22: '',
                p23: '',
                p24: '',
                p25: '',
                p26: '',
                p27: '',
                p28: '',
                p29: '',
                p30: '',
                p31: '',
                p32: '',
                p33: ''
            }

            let index_global = 0;
            self.precios_imprimir.forEach((element, index) => {

                var _id = (element.precio_1.producto + '');
                _id = _id.replace(/-/g, "")
                paramsObject['p' + (index + 1)] = _id;
                paramsObject['id' + index_global] = _id;

            });

            var query_params = Object.keys(paramsObject)
                .filter(function (key) {
                    return paramsObject[key] ? true : false
                })
                .map(function (key) {
                    return encodeURIComponent(key) + '=' + encodeURIComponent(paramsObject[key])
                })
                .join('&');
            var url =
                baseApiUrl +
                "/cat/reporte/?report_name=" +
                reportName +
                query_params;
            window.open(url);
        },
        ImprimirMedianos() {
            let self = this;
            const baseApiUrl = process.env.VUE_APP_ROOT_API;
            var reportName = "catalogos/Habladores_MINISO/HabladoresCarta7x6.jrxml&";


            let paramsObject = {
                tienda: self.tienda_id,
                p1: '',
                p2: '',
                p3: '',
                p4: '',
                p5: '',
                p6: '',
                p7: '',
                p8: '',
            }

            let index_global = 0;
            self.precios_imprimir.forEach((element, index) => {

                var _id = (element.precio_1.producto + '');
                _id = _id.replace(/-/g, "")
                paramsObject['p' + (index + 1)] = _id;
                paramsObject['id' + index_global] = _id;

            });

            var query_params = Object.keys(paramsObject)
                .filter(function (key) {
                    return paramsObject[key] ? true : false
                })
                .map(function (key) {
                    return encodeURIComponent(key) + '=' + encodeURIComponent(paramsObject[key])
                })
                .join('&');
            var url =
                baseApiUrl +
                "/cat/reporte/?report_name=" +
                reportName +
                query_params;
            window.open(url);
        },
        refreshDataDefault() {
            let self = this;
            self.datos = [];
            self.datos_ = [];
            self.precios_imprimir = [];
            self.tienda_id = null;
            self.current.tienda = "";
            self.current.producto = "";
        },
        seleccionProducto(producto) {
            let self = this;
            DynamicService.getByIdParams("cat", "productos", producto.sku, {
                tienda: self.current.tienda,
                sku: producto.sku,
            }).then((response) => {
                console.log(response.data);
                self.current.precios_lista = response.data.lista_precios;

                self.current.precio_1 = self.current.precios_lista[self.current.precios_lista.length - 1];
                self.current.precio_2 = self.current.precios_lista[0];

            });
        },
        quitarItem(current_preview) {
            let self = this;
            console.log(current_preview)
            let idxObj = self.precios_imprimir.findIndex(object => {
                return (
                    (object.precio_1.id == current_preview.precio_1.id)
                );
            });


            self.precios_imprimir.splice(idxObj, 1);

        },
        onChangePrecio1(event) {
            alert('')
        },
        convertToInt(precio) {
            return parseInt(precio)
        }
    },
};
</script>
